import {
  Button, Col,
  Flex, Row
} from "antd";
import { lazy, Suspense } from "react";
import Layout from "../components/layout";
import HeroScreen from "../components/HeroScreen/heroScreen";
import classes from "../components/HeroScreen/heroScreen.module.css";
import { useNav } from "../hooks/useNav";

const HowItWorks = lazy(() => import("../components/Screens/howItWorks"));
const AboutScreen = lazy(() => import("../components/Screens/about"));
const GreySection = lazy(() => import("../components/Screens/greySection"));

const PsychoOncology = () => {
  const { navExperts } = useNav();

  return (
    <Layout>
      <HeroScreen imgSrc="/landing/psycho-oncology/hero.png">
        <h1 className="heroTitle">Psiconcologia</h1>
        <Flex
          vertical
          gap={16}
          className={classes.text}
        >
          <p>
            Benvenuto nella nostra piattaforma di supporto psiconcologico online.
          </p>
          <p>
            Qui troverai un sostegno emotivo e psiconcologico altamente qualificato,
            fornito da professionisti sanitari esperti nel settore.
            Comprendiamo le condizioni emotive e psicologiche che accompagnano
            la diagnosi e il trattamento del cancro.
            Offriamo un supporto personalizzato e su misura per aiutarti
            ad affrontare ogni fase del percorso con forza e serenità.
          </p>
        </Flex>
      </HeroScreen>
      <Suspense>
        <GreySection
          title="A chi ci rivolgiamo?"
          description="Sosteniamo chiunque sia coinvolto nel percorso oncologico: pazienti, caregiver, famiglie e operatori sanitari. Ogni gruppo ha esigenze specifiche, e noi siamo qui per rispondere con servizi su misura."
        >
          <Row gutter={[24, 24]} className="py-[3rem]">
            <Col span={24} lg={6}>
              <img src="/landing/psycho-oncology/img-1.png" alt="img" className="w-full"/>
              <p className="mt-4 mb-0 text-base font-bold">Pazienti Oncologici</p>
            </Col>
            <Col span={24} lg={6}>
              <img src="/landing/psycho-oncology/img-2.png" alt="img" className="w-full"/>
              <p className="mt-4 mb-0 text-base font-bold">Caregivers</p>
            </Col>
            <Col span={24} lg={6}>
              <img src="/landing/psycho-oncology/img-3.png" alt="img" className="w-full"/>
              <p className="mt-4 mb-0 text-base font-bold">Famiglie e Amici</p>
            </Col>
            <Col span={24} lg={6}>
              <img src="/landing/psycho-oncology/img-4.png" alt="img" className="w-full"/>
              <p className="mt-4 mb-0 text-base font-bold">Medici, Infermieri e Operatori Sanitari</p>
            </Col>
          </Row>
        </GreySection>
      </Suspense>
      <Suspense>
        <AboutScreen
          title="I nostri psiconcologi"
          imgSrc="/landing/psycho-oncology/about.png"
          button={(
            <Button type="dashed" size="large" onClick={() => navExperts()}>
              Scopri gli specialisti
            </Button>
          )}
        />
      </Suspense>
      <Suspense>
        <HowItWorks/>
      </Suspense>
    </Layout>
  );
};

export default PsychoOncology;
